import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/tourisme-laurentides-theme.module.css';

interface TourismeLaurentidesThemeProps extends HTMLAttributes<HTMLDivElement> {
    className?: string | null;
    children: ReactNode;
}

function TourismeLaurentidesTheme({
    children,
    className = null,
    ref = null,
    ...props
}: TourismeLaurentidesThemeProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default TourismeLaurentidesTheme;
